import { render } from "./App.vue?vue&type=template&id=52c5d1e3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=52c5d1e3&lang=less"

import exportComponent from "D:\\fuda\\司法鉴定\\web_sfjd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__